import React from 'react';
import { SectionCap, EditorialButton, EmptyState } from '../Editorial';

/* The Free matches view.
 *
 * These rows are EMPTY on purpose. The server sends no school data to a Free
 * athlete (design spec §3.1), so there is nothing here to un-blur — the blur
 * is a treatment over absence, not a cover over content. Never populate these
 * from a cached Pro response.
 *
 * Header chrome matches the sibling Recruit panels (FollowingPanel,
 * VisitsPanel, OffersPanel): an unconditional <SectionCap>, present in the
 * empty state too, so a Free athlete sees the same panel chrome here as on
 * every other Recruit tab rather than a bespoke "locked" look.
 */
const PLACEHOLDER_ROWS = 5;

export default function LockedMatches({ total = 0, onUpgrade }) {
  if (!total) {
    return (
      <>
        <SectionCap label="Your Matches" />
        <EmptyState
          title="No matches yet"
          body="Complete your profile — the more we know, the more colleges we can rank for you."
        />
      </>
    );
  }

  return (
    <div data-testid="matches_locked">
      <SectionCap label="Your Matches" hint={`${total} found`} />

      <div className="rc-locked" aria-hidden="true">
        {Array.from({ length: Math.min(total, PLACEHOLDER_ROWS) }).map((_, i) => (
          <div key={i} className="rc-locked__row" data-testid="match_placeholder_row">
            <span className="rc-locked__logo" />
            <span className="rc-locked__lines">
              <span className="rc-locked__bar rc-locked__bar--wide" />
              <span className="rc-locked__bar rc-locked__bar--narrow" />
            </span>
            <span className="rc-locked__score" />
          </div>
        ))}
      </div>

      <div style={{ textAlign: 'center', marginTop: 18 }}>
        <EditorialButton onClick={onUpgrade} data-testid="matches_upgrade_cta">
          {`Go Pro to see your ${total} best matches`}
        </EditorialButton>
        <p className="ed-muted" style={{ fontSize: 13, marginTop: 8 }}>
          See which colleges fit you, and why — ranked across every signal on your profile.
        </p>
      </div>
    </div>
  );
}
